'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationMessageType,
  ConversationMessage,
  Message as MessageType,
  MessagePhotoModel,
} from '@marketplace-web/messaging/conversation-messaging-data'

import PhotoMessage from '../../PhotoMessage'
import Message from '../../Message'

type Props = ConversationMessage & {
  message: MessageType
  isGrouped: boolean
  isLast: boolean
  isCurrentAuthor: boolean
}

const UserMessage = ({
  message,
  isGrouped,
  isLast,
  isCurrentAuthor,
  entityType,
  createdTime,
}: Props) => {
  const { conversation } = useConversationContext()
  const isReadByOppositeUser = conversation?.isReadByOppositeUser

  const renderPhotoMessage = (photo: MessagePhotoModel, index: number) => {
    const isLastAndRead = isLast && !!isReadByOppositeUser && index + 1 === message.photos.length

    return (
      <PhotoMessage
        key={index}
        photo={photo}
        isCurrentAuthor={isCurrentAuthor}
        isLastAndRead={isLastAndRead}
        isLast={isLast}
        showTime={index === 0}
        createdTime={createdTime}
        messageId={message.id}
      />
    )
  }

  const isMessageBubbleVisible = message.content || message.isHidden

  return (
    <>
      {isMessageBubbleVisible && (
        <Message
          isCurrentAuthor={isCurrentAuthor}
          message={message}
          createdTime={createdTime}
          isPortalMessage={entityType === ConversationMessageType.PortalMessage}
          isGrouped={isGrouped}
          isLast={isLast}
          isLastAndRead={isLast && !!isReadByOppositeUser}
        />
      )}
      {message.photos.map(renderPhotoMessage)}
    </>
  )
}

export default UserMessage
